import React from 'react'

/* doc
---
title: MessageHeader
name: MessageHeader
category: React - Bulma
parent: Message
---

A `MessageHeader` component based on Bulma `.message-header`. This is used to
add a title bar to the `Message` component.

This should be used as a child of the `Message` component.

See [Bulma Documentation](http://bulma.io/documentation/components/message/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.

```html_example
  <Message>
    <MessageHeader>
      ...
    </MessageHeader>
  </Message>
```
*/
function MessageHeader(props) {
  const { className, children, ...rest } = props

  const classes = [
    'message-header',
    className || '',
  ]

  return (
    <header {...rest} className={classes.join(' ')}>
      {children}
    </header>
  )
}

export default MessageHeader
